"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createMeetingEventObserver = require("./createMeetingEventObserver");
Object.keys(_createMeetingEventObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createMeetingEventObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createMeetingEventObserver[key];
    }
  });
});